<template>
  <el-form ref="formData" :model="formData" :rules="rules">
    <el-form-item prop="email" :label="$t('users.email')" required>
      <el-input
        class="no-border input-lg"
        type="email"
        v-model="formData.email"
        prefix-icon="el-icon-user"
      >
      </el-input>
    </el-form-item>
    <div class="text-center">
      <el-button class="btn-primary btn btn-lg" size="large" round type="primary" @click="onLoginSubmit()">{{$t('restore.button')}}</el-button>
    </div>
    <div class="text-center">
      <h4>
        <el-link icon="el-icon-user" type="info" @click="showSignUpModal">{{$t('menu.login')}}</el-link>
      </h4>
    </div>
  </el-form>
</template>
<script>
import { Card, Alert } from '@/components';
import { Input, Button, Form, FormItem, Link, Message } from 'element-ui';
import Auth from '@/providers/Auth'

const AuthProvider = new Auth()

export default {
  components: {
    Card,
    [Input.name]: Input,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Button.name]: Button,
    [Link.name]: Link,
    Alert
  },
  data: () => ({
      formData: {
        email: null
      },
      loading: false,
      error: null,
      success: null,
      rules: {
        email: [{ required: true, message: 'Correo electrónico es obligatorio', trigger: 'blur', type: 'email' }]
      }
  }),
  methods: {
    onLoginSubmit () {
      this.$refs['formData'].validate((valid) => {
          if (valid) {
            this.loading = true
            AuthProvider.requestRestorePassword(this.formData).then((resp)=> {
                this.loading = false
                this.error = null
                Message({ type: 'success', message: 'Verifica tu bandeja de entrada y sigue las instrucciones para reestablecer tu contraseña' })
            }).catch((err)=>{
              this.loading = false
              if(err && err.status && (err.status === 400)) {
                Message({ type: 'error', message: 'Datos incorrectos' })
              }else if(err && err.status && (err.status === 403)) {
                Message({ type: 'error', message: 'Porfavor confirma tu cuenta e intenta de nuevo' })
              }else {
                Message({ type: 'error', message: 'Error de comunicación' })
              }
            })
          } else {
            return false;
          }
      })
    },
    showSignUpModal() {
      this.$refs['formData'].resetFields();
      this.$emit('show-login');
    }
  }
};
</script>
<style></style>
